<template>
  <div class="fabric-container">
    <div class="d-flex align-items-center">
      <span style="font-size: 15px;font-weight: 600; color: #2B3447">
        {{ $l('INDEX.evg_sku_label_fabric_composition') || '面料构成' }}
      </span>
      <el-divider direction="vertical" v-if="!disabled"></el-divider>
      <div v-if="!disabled">
        <el-button
          :disabled="isChecked"
          @click="chooseFabric"
          size="mini"
          class="ml-2"
        >
          {{
            $l('INDEX.evg_sku_label_batch_set_fabric') || '批量设置面料'
          }}</el-button
        >
      </div>
    </div>
    <div class="fabric-list-info__container">
      <div v-for="(item, index) in specList" :key="item.id">
        <FabricSpec
          ref="fabricSpecRef"
          :currIndex="index"
          :evgSkuCode="evgSkuCode"
          :specInfo="item"
          :disabled="disabled"
          @checkSpec="checkSpec"
          @delCheck="delCheck"
          @addFabric="addFabric"
        ></FabricSpec>
      </div>
      <div v-if="isEmpty" class="no-data__wrapper">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </div>
    </div>
    <FabricBatchSetting
      v-if="fabricBatchVisible"
      :visible.sync="fabricBatchVisible"
      :disabled="disabled"
      :title="title"
      :evgSkuSpecCode="evgSkuSpecCode"
      @close="closeFabricBatchSetting"
      @saveBatch="saveBatch"
    ></FabricBatchSetting>
  </div>
</template>
<script>
import FabricSpec from './fabric-spec'
import FabricBatchSetting from './fabric-batch-setting'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { FabricSpec, FabricBatchSetting },
  props: {
    disabled: { type: Boolean, default: true },
    evgSkuCode: { type: String, default: '' },
  },
  mixins: [EditLoading],
  data() {
    return {
      specList: [],
      checkSpecList: [],
      evgSkuSpecCode: '',
      title: '',
      fabricBatchVisible: false,
      addFabricVisible: false,
    }
  },
  mounted() {
    this.initSpec()
  },
  computed: {
    isEmpty() {
      return !this.specList.length
    },
    isChecked() {
      return !this.checkSpecList.length
    },
  },
  methods: {
    initSpec() {
      if (!this.evgSkuCode) return
      this.$api
        .ecomEvgSkuSpecListApi({
          evgSkuCode: this.evgSkuCode,
        })
        .then((res) => {
          this.specList = []
          this.specList = res.body.data
        })
    },
    checkSpec(e) {
      this.checkSpecList.push({ ...e })
    },
    delCheck({ evgSkuSpecCode }) {
      const index = this.checkSpecList.findIndex(
        (item) => item.evgSkuSpecCode === evgSkuSpecCode
      )
      this.checkSpecList.splice(index, 1)
    },
    chooseFabric() {
      this.fabricBatchVisible = true
      this.title = this.$l('INDEX.evg_sku_label_batch_set_fabric') || '批量设置面料'
    },
    addFabric(code) {
      this.fabricBatchVisible = true
      //单个新增
      this.addFabricVisible = true
      this.evgSkuSpecCode = code
      this.title = this.$l('INDEX.evg_sku_label_set_fabric') || '单个设置面料'
    },
    addBatch(fabricData) {
      this.loadingOpen()
      this.$api
        .ecomEvgSkuSpecFabricEditSaveApi({
          evgSkuSpecCode: this.evgSkuSpecCode,
          saves: fabricData,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.reloadFabricInfo()
          this.fabricBatchVisible = false
          this.addFabricVisible = false
          this.evgSkuSpecCode = ''
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    saveBatch(fabricData) {
      if (this.addFabricVisible) {
        this.addBatch(fabricData)
        return
      }
      const codes = this.checkSpecList.map((e) => {
        return e.evgSkuSpecCode
      })
      this.loadingOpen()
      this.$api
        .ecomEvgSkuSpecFabricSaveBatchApi({
          codes,
          saves: fabricData,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.checkSpecList = []
          this.reloadFabricInfo()
          this.fabricBatchVisible = false
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    reloadFabricInfo() {
      const fsr = this.$refs.fabricSpecRef || []
      for (let i = 0; i < fsr.length; i++) {
        fsr[i].initFabric()
      }
    },
    closeFabricBatchSetting() {
      this.fabricBatchVisible = false
      this.addFabricVisible = false
      this.evgSkuSpecCode = ''
    },
  },
}
</script>
<style lang="scss" scoped>
.no-data__wrapper {
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fabric-list-info__container {
  margin-top: 10px;
}
</style>
